import { Autocomplete, Box, Card, FormControlLabel, Modal, Radio, RadioGroup, TextField, Typography } from "@mui/material"
import Button from "@mui/material/Button";
import classnames from "classnames";
import React from "react"
import { useDispatch, useSelector } from "react-redux";
import { appdataSelector, appdata_setSnackbar } from "reducers/appdata/appdata";
import { vendordataSelector, vendordata_getBankData } from "reducers/vendordata/vendordata";
import VendorEditableBankSearchDatagrid from "./VendorEditableBankSearchDatagrid";

function VendordataEditableBankSearch(props) {
    const appdata = useSelector(appdataSelector);
    const vendordata = useSelector(vendordataSelector);
    const dispatch = useDispatch();
    const [searchType, setSearchType] = React.useState("Iban");

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "90%",
        maxHeight: "90%",
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        overflow: "scroll"
    };

    const InputFields = [
        { label: "Bank Key", id: "bank_code" },
        { label: "Bank Name", id: "bank_name" },
        { label: "City", id: "bank_city" },
        { label: "SWIFT/BIC", id: "bank_swift" },
        { label: "Bank Branch", id: "bank_branch" },
        { label: "Street/House", id: "bank_street" },
        { label: "Restrict Number", id: "max_rec",classname:"mt-5", width:150 },
    ]

    const handleChangeSearchtype = (event) => {
        setSearchType(event.target.value);
    }

    const [newBank, setNewBank] = React.useState({max_rec:500});

    const isAllowedToSearch = () => {
        //console.log("check");


        if (newBank.bank_country != null) {
            return true;
        }

        return false;

        if (searchType && searchType == "Iban") {
            if (
                newBank.bank_code != null &&
                newBank.bank_country != null
            ) {
                //console.log("bank data is ok on Iban, sent!");
                return true;
            }

        }
        else if (searchType && searchType == "Bankkey") {
            if (
                newBank.bank_account != null &&
                newBank.bank_code != null &&
                newBank.bank_country != null
            ) {
                //console.log("bank data is ok on BankKey, sent!");
                return true;
            }
        }

        return false;
    }

    const handleClose = () => {
        console.log("handle close")
    }

    const handleSearchBankData = () => {
        console.log("search!");
        if (isAllowedToSearch()) {
            console.log("allowed");
            dispatch(vendordata_getBankData(newBank))
        }
        else {
            dispatch(appdata_setSnackbar({ severity: "error", open: true, message: "Please fill out all required fields" }))
        }
    }



    let country = "";

    if (newBank.bank_country) {
        if (appdata.listvalues.countryDropdownValues) {
            appdata.listvalues.countryDropdownValues.map((item, key) => {
                if (item["LAND1"] === newBank.bank_country) country = item;
            });
        }
    }


    return (
        <Card className="p-4 mt-2" key="Searchcard">

            <div key="banksearchdiv">

                <Autocomplete
                    key = "autocomp1"
                    style={{
                        width: 400,
                        backgroundColor: "white"
                    }}
                    id="typedropdown"
                    options={appdata.listvalues.countryDropdownValues}
                    value={country ? country : null}
                    getOptionLabel={option => {
                        if (!option) return null;
                        return option["LAND1"] + " - " + option["LANDX"];
                    }}
                    // what is displayed:
                    renderOption={(props, option, index) => {
                        const key = props.id;
                        return (
                            <li {...props} key={key}>
                                {option["LAND1"]} - {option["LANDX"]}
                            </li>
                        );
                    }}
                    renderInput={params => (
                        <TextField {...params} label="Country*" variant="outlined" />
                    )}
                    onChange={(event, value) => {
                        setNewBank(prevState => ({
                            ...prevState,
                            ["bank_country"]: value["LAND1"]
                        }));
                    }}
                />

                {InputFields.map(field => {
                    return (
                        <div className={field.classname ? field.classname : "mt-2"} key={field.id + "div"}>
                            <TextField
                                key={field.id + "textfield"}
                                style={{
                                    width: field.width ? field.width : 400 ,
                                    backgroundColor: "white"
                                }}
                                value={newBank[field.id] ? newBank[field.id] : ""}
                                id="outlined-basic"
                                label={field.label}
                                /* defaultValue={field.default ? field.default : "aa"} */
                                variant="outlined"
                                onChange={(event, value) => {
                                    setNewBank(prevState => ({
                                        ...prevState,
                                        [field.id]: event.target.value
                                    }));
                                }}
                            /></div>)
                })}


                <Modal
                    open={Object.keys(vendordata.banks).length > 0}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <VendorEditableBankSearchDatagrid />
                    </Box>
                </Modal>


            </div>


            {searchType && searchType == "Iban" && false && (
                <div>
                    {/* country dropdown */}
                    {/* country dropdown */}
                    {/* country dropdown */}
                    {/* country dropdown */}
                    <Autocomplete
                        style={{
                            width: 400,
                            backgroundColor: "white"
                        }}
                        id="typedropdown"
                        options={appdata.listvalues.countryDropdownValues}
                        value={country ? country : null}
                        getOptionLabel={option => {
                            if (!option) return null;
                            return option["LAND1"] + " - " + option["LANDX"];
                        }}
                        // what is displayed:
                        renderOption={(props, option, index) => {
                            const key = props.id;
                            return (
                                <li {...props} key={key}>
                                    {option["LAND1"]} - {option["LANDX"]}
                                </li>
                            );
                        }}
                        renderInput={params => (
                            <TextField {...params} label="Country*" variant="outlined" />
                        )}
                        onChange={(event, value) => {
                            setNewBank(prevState => ({
                                ...prevState,
                                ["bank_country"]: value["LAND1"]
                            }));
                        }}
                    />
                    {/* end country dropdown */}
                    {/* end country dropdown */}
                    {/* end country dropdown */}
                    {/* end country dropdown */}
                    <br></br>
                    {/* bank code  */}
                    {/* bank code  */}
                    {/* bank code  */}
                    {/* bank code  */}
                    <TextField
                        style={{
                            width: 400,
                            backgroundColor: "white"
                        }}
                        value={newBank.bank_code ? newBank.bank_code : ""}
                        id="outlined-basic"
                        label="Bank Code*"
                        variant="outlined"
                        onChange={(event, value) => {
                            setNewBank(prevState => ({
                                ...prevState,
                                ["bank_code"]: event.target.value
                            }));
                        }}
                    />
                    {/* end bank code  */}
                    {/* end bank code  */}
                    {/* end bank code  */}
                    {/* end bank code  */}
                    <br></br>
                    <br></br>
                    {/* iban */}
                    {/* iban */}
                    {/* iban */}
                    {/* iban */}
                    {/* iban */}
                    <TextField
                        style={{
                            width: 400,
                            backgroundColor: "white"
                        }}
                        value={newBank.iban ? newBank.iban : ""}
                        id="outlined-basic"
                        label="Iban"
                        variant="outlined"
                        onChange={(event, value) => {
                            setNewBank(prevState => ({
                                ...prevState,
                                ["iban"]: event.target.value
                            }));
                        }}
                    />
                    {/* end iban */}
                    {/* end iban */}
                    {/* end iban */}
                    {/* end iban */}
                    {/* end iban */}
                </div>
            )}



            {searchType && searchType == "Bankkey" && false && (
                <div>
                    {/* country dropdown */}
                    {/* country dropdown */}
                    {/* country dropdown */}
                    {/* country dropdown */}
                    <Autocomplete
                        style={{
                            width: 400,
                            backgroundColor: "white"
                        }}
                        id="typedropdown"
                        options={appdata.listvalues.countryDropdownValues}
                        value={country ? country : null}
                        getOptionLabel={option => {
                            if (!option) return null;
                            return option["LAND1"] + " - " + option["LANDX"];
                        }}
                        // what is displayed:
                        renderOption={(props, option, index) => {
                            const key = props.id;
                            return (
                                <li {...props} key={key}>
                                    {option["LAND1"]} - {option["LANDX"]}
                                </li>
                            );
                        }}
                        renderInput={params => (
                            <TextField {...params} label="Country*" variant="outlined" />
                        )}
                        onChange={(event, value) => {
                            setNewBank(prevState => ({
                                ...prevState,
                                ["bank_country"]: value["LAND1"]
                            }));
                        }}
                    />
                    {/* end country dropdown */}
                    {/* end country dropdown */}
                    {/* end country dropdown */}
                    {/* end country dropdown */}

                    <br></br>

                    {/* bank code  */}
                    {/* bank code  */}
                    {/* bank code  */}
                    {/* bank code  */}
                    <TextField
                        style={{
                            width: 400,
                            backgroundColor: "white"
                        }}
                        value={newBank.bank_code ? newBank.bank_code : ""}
                        id="outlined-basic"
                        label="Bank Code*"
                        variant="outlined"
                        onChange={(event, value) => {
                            setNewBank(prevState => ({
                                ...prevState,
                                ["bank_code"]: event.target.value
                            }));
                        }}
                    />
                    {/* end bank code  */}
                    {/* end bank code  */}
                    {/* end bank code  */}
                    {/* end bank code  */}
                    <br></br>
                    {/* bank account */}
                    {/* bank account */}
                    {/* bank account */}
                    {/* bank account */}
                    <TextField
                        style={{
                            marginTop: 20,
                            width: 400,
                            backgroundColor: "white"
                        }}
                        value={newBank.bank_account ? newBank.bank_account : ""}
                        id="outlined-basic"
                        label="Bank Account*"
                        variant="outlined"
                        onChange={(event, value) => {
                            setNewBank(prevState => ({
                                ...prevState,
                                ["bank_account"]: event.target.value
                            }));
                        }}
                    />
                    {/* end bank account */}
                    {/* end bank account */}
                    {/* end bank account */}
                    {/* end bank account */}
                </div>
            )}
            <br></br>
            {searchType && (

                <Button
                    className={classnames("besiButton", "d-print-none")}
                    variant="contained"
                    key="savebutton"
                    onClick={() => handleSearchBankData()}
                >
                    Search
                </Button>
            )}
        </Card>
    )
}
export default VendordataEditableBankSearch